
import HttpClient from './HttpClient';
class ProfileAPI {
  // Get all profiles with proper parameters
  getAllProfiles(companyId, params = {}) {
    return HttpClient.get('Profile', {
      companyId,
      page: params.page || 1,
      pageSize: params.pageSize || 25,
      search: params.search || '',
      sortBy: params.sortBy || '',
      sortDirection: params.sortDirection || 'asc'
    });
  }

  // ✅ FIX: Always include profileType parameter
  getProfileById(id, profileType) {
    if (!profileType) {
      console.error('profileType is required for getProfileById');
      return Promise.reject(new Error('profileType is required'));
    }
    return HttpClient.get(`Profile/${id}`, { profileType });
  }

  // Get profiles by type (Vendor, Customer, Employee)
  getProfilesByType(profileType, companyId, params = {}) {
    return HttpClient.get(`Profile/type/${profileType}`, {
      companyId,
      page: params.page || 1,
      pageSize: params.pageSize || 25,
      search: params.search || '',
      sortBy: params.sortBy || '',
      sortDirection: params.sortDirection || 'asc'
    });
  }

  // ✅ FIX: Create profile with all required fields
  createProfile(companyId, profileData) {
    return HttpClient.post('Profile', {
      ...profileData,
      companyId
    });
  }

  // ✅ FIX: Update profile with profileType parameter
  updateProfile(id, profileType, profileData) {
    if (!profileType) {
      console.error('profileType is required for updateProfile');
      return Promise.reject(new Error('profileType is required'));
    }
    return HttpClient.put(`Profile/${id}`, profileData, { profileType });
  }

  // Delete profile
  deleteProfile(id, profileType) {
    return HttpClient.delete(`Profile/${id}`, { profileType });
  }

  // Get profile transactions (ledger)
  getProfileTransactions(profileId, profileType, fromDate, toDate) {
    return HttpClient.get(`Profile/${profileId}/transactions`, {
      profileType,
      fromDate,
      toDate
    });
  }

  // Get profile statistics
  getProfileStatistics(profileId, profileType) {
    return HttpClient.get(`Profile/${profileId}/statistics`, {
      profileType
    });
  }

  // ✅ NEW: Get next code for profile
  getNextCode(profileType, companyId) {
    return HttpClient.get('Profile/next-code', {
      profileType,
      companyId
    });
  }
}

export default new ProfileAPI();